import React from "react";
import "./Heading.css";

export default function Heading({
  children,
  as: Component = "h2",
  size = "md",
  className = "",
  ...props
}) {
  return (
    <Component
      className={["ko-heading", `ko-heading--${size}`, className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
